import { createWebHistory, createRouter } from 'vue-router'
import routes from './routes'
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果有保存的位置（例如使用浏览器的前进/后退按钮），则返回保存的位置
        if (savedPosition) {
            return savedPosition
        } else {
            // 否则滚动到顶部
            return { top: 0 }
        }
    }
})

export default router